export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CZ-23283bc4af7a6d5835da86e5c6af3e80.png";